import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import '../../Custom.css';
import {IComboBoxOption, IconButton, IIconProps, Modal, Nav, Panel, PanelType, Stack, Text} from "@fluentui/react";
import {ApprovalEdit, ApprovalSteps, contentStyles, iconButtonStyles, navStyles, setDefaultOptions} from "./index"
import {useBranding} from '../../hooks/useBranding';
import ApprovalService, {
    IGetApprovalListMasterRequest,
    IGetApprovalListMasterResponse,
    IGetApprovalStepResponse
} from "../../services/Approval";
import HelpComponentRelative from "../Help/HelpComponentRelative";
import RenewalsAndAlertsService from "../RenewalsAndAlerts/RenewalsAndAlerts.service";
import {ILayout} from "../CustomTemplates/CustomTemplate";

type Properties = {
    titleId: string,
    cancel: any
    getLinkGroup: any
    option: string
    setIsOpenMenu: any
    showModal: any
    onLinkClick: any
    templateId: string,
    documentOnlyAudienceId: string,
    isOpenMenu: any
}

export function Approval({
                             showModal,
                             option,
                             templateId,
                             documentOnlyAudienceId,
                             getLinkGroup,
                             titleId,
                             cancel,
                             isOpenMenu,
                             onLinkClick,
                             setIsOpenMenu
                         }: Properties) {

    const {branding} = useBranding()
    const {t} = useTranslation(['approval', 'common'])

    const cancelIcon: IIconProps = {iconName: 'Cancel'};
    const menuIcon: IIconProps = {iconName: 'GlobalNavButton'};


    const [currentItem, setCurrentItem] = useState<IGetApprovalStepResponse | null>(null)
    const [selectedPivot, setSelectedPivot] = useState('process')
    const [steps, setSteps] = useState<IGetApprovalStepResponse[]>([])
    const [templateContentControls, setTemplateContentControls] = useState<IComboBoxOption[]>([])
    const [mapContentControls, setMapContentControls] = useState<IComboBoxOption[]>([])
    const [masterLists, setMasterLists] = useState<IGetApprovalListMasterResponse[]>([])

    useEffect(() => {
        if (showModal) {
            loadLists().then()
            loadContentControls().then()
            setCurrentItem(null)
            setSelectedPivot('process')
        }
    }, [])


    /**
     * Load Master Lists
     */
    const loadLists = async () => {

        setMasterLists([])
        const request: IGetApprovalListMasterRequest = {
            Mode: 'audienceId',
            Id: documentOnlyAudienceId
        }

        await ApprovalService.getApprovalListMaster(request)
            .then(data => {
                if (data.Success) {
                    try {
                        const resultData = JSON.parse(data.Result) as Array<IGetApprovalListMasterResponse>
                        if (Array.isArray(resultData)) {
                            setMasterLists(resultData)

                        }
                    } catch {

                    }
                }
            })
    }


    /**
     * Load Content Controls
     */
    const loadContentControls = async () => {
        setTemplateContentControls([])
        setMapContentControls([])

        await RenewalsAndAlertsService.getStatemanagement({
            User: "",
            templateId: parseInt(templateId!)
        }).then(data => {
            try {
                const items = JSON.parse(data.Layout as string) as ILayout[]
                if (Array.isArray(items)) {
                    setTemplateContentControls(setDefaultOptions(items, true))
                    setMapContentControls(setDefaultOptions(items, false))
                }
            } catch {

            }

        }).catch()
    }


    return (
        <>
            <Modal
                isOpen={showModal}
                isBlocking={true}
                containerClassName={contentStyles(branding.theme).newContainer}
            >

                <Stack grow={1} styles={{root: {height: "100%"}}}>

                    <Stack tokens={{childrenGap: 8}} styles={{
                        root: {
                            height: 56,
                            alignItems: 'center'
                        }
                    }} horizontal>

                        <Stack className="ms-hiddenXlUp">

                            <IconButton iconProps={menuIcon} style={{marginLeft: "-4px", paddingLeft: "16px"}}
                                        title={t('text.Menu', {ns: 'workspace'})} onClick={setIsOpenMenu}/>
                            <Panel
                                isBlocking={false}
                                isOpen={isOpenMenu}
                                onDismiss={setIsOpenMenu}
                                closeButtonAriaLabel={t('Common.Button.Close', {ns: 'common'})}
                                type={PanelType.smallFixedNear}
                            >
                                <Nav
                                    groups={getLinkGroup}
                                    onLinkClick={onLinkClick}
                                    selectedKey={option}
                                    styles={navStyles}
                                />
                            </Panel>

                        </Stack>

                        <Stack grow={1}
                               styles={{
                                   root: {
                                       textOverflow: "ellipsis",
                                       paddingLeft: 16,
                                       whiteSpace: "nowrap",
                                       overflow: "hidden"
                                   }
                               }}>
                            <Text
                                variant={"xLarge"}
                                id={titleId}
                                title={t('title.modal', {ns: 'approval'})}>
                                {t('title.modal', {ns: 'approval'})}
                            </Text>
                        </Stack>

                        <Stack horizontal styles={{root: {alignItems: "center", paddingRight: 8}}}>
                            <HelpComponentRelative
                                headline={t('title.help', {ns: 'approval'})}
                                text={t('text.help', {ns: 'approval', AppName: branding.appName})}
                                location=""
                            />
                            <IconButton
                                styles={iconButtonStyles}
                                iconProps={cancelIcon}
                                ariaLabel={t('Common.Button.Close', {ns: 'common'})}
                                onClick={cancel}
                                title={t('Common.Button.Close', {ns: 'common'})}
                            />
                        </Stack>
                    </Stack>
                    <Stack grow={1} styles={{root: {height: 1}}}>

                        <Stack horizontal styles={{root: {height: '100%'}}}>

                            <Stack className={"ms-hiddenLgDown scrollVisible"} styles={{
                                root: {
                                    overflowY: 'auto',
                                    height: '100%',
                                    width: 240, paddingLeft: 16
                                }
                            }}>
                                <Nav
                                    groups={getLinkGroup}
                                    onLinkClick={onLinkClick}
                                    selectedKey={option}
                                    styles={navStyles}
                                />
                            </Stack>

                            <Stack grow={1} styles={{root: {height: '100%', width: 1}}}>

                                {selectedPivot === 'process' &&

                                    <ApprovalEdit
                                        cancel={cancel}
                                        currentItem={currentItem}
                                        setCurrentItem={setCurrentItem}
                                        setSelectedPivot={setSelectedPivot}
                                        setSteps={setSteps}
                                        steps={steps}
                                        templateId={templateId}
                                    />
                                }

                                {selectedPivot === 'steps' &&

                                    <ApprovalSteps
                                        masterLists={masterLists}
                                        currentItem={currentItem}
                                        documentOnlyAudienceId={documentOnlyAudienceId}
                                        mapContentControls={mapContentControls}
                                        setSelectedPivot={setSelectedPivot}
                                        steps={steps}
                                        templateContentControls={templateContentControls}
                                        templateId={templateId}
                                    />

                                }

                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Modal>
        </>
    )
}
